module.exports = __webpack_public_path__ + "img/LGGJSC1.50d42278.jpg";